export enum EBAY_LISTINGS_ACTIONS_TYPES {
  RETRY = 'retry',
  CANCEL = 'cancel',
  SHOW_DESCRIPTION = 'showDescription',
  EDIT_DESCRIPTION = 'editDescription',
  DELETE = 'delete',
  REMOVE_TEMPLATE = 'removeTemplate',
  RESTORE_ORIGINAL_DESIGN = 'restoreOriginalDesign',
  PICK_TEMPLATE_TO_APPLY = 'pickTemplateToApply',
  SAVE_AND_REVISE = 'saveAndRevise',
  APPLY_TEMPLATE = 'applyTemplate',
  OPEN_DUPLICATE_LISTINGS_DIALOG = 'openDuplicateListingsDialog',
  DUPLICATE_LISTINGS = 'duplicateListings',
  DUPLICATE_LISTING_AND_EDIT = 'duplicateListingAndEdit',
  OPEN_END_LISTINGS_DIALOG = 'openEndListingsDialog',
  END_LISTINGS = 'endListings',
  SAVE_DRAFT = 'saveDraft',
  SAVE_AND_PUBLISH = 'saveAndPublish',
  REFRESH_LISTING_FROM_EBAY = 'refreshListingFromEbay',
  RESET_CHANGES = 'resetChanges',
  FIND_EBAY_PRODUCT = 'findEbayProduct',
  REPORT_MISSING_EBAY_PRODUCT = 'reportMissingEbayProduct',
  CONTINUE_WITHOUT_EBAY_PRODUCT = 'continueWithoutEbayProduct',
  MORE_DETAILS_EBAY_PRODUCT = 'moreDetailsEbayProduct',
  PUBLISH_PRODUCTS_TO_EBAY = 'publishProductsToEbay',
  OPEN_ADD_VARIATION_DIALOG = 'openAddVariationDialog',
  OPEN_EDIT_VARIATION_OPTIONS_DIALOG = 'openEditVariationOptionsDialog',
  ADD_SINGLE_VARIATION = 'addSingleVariation',
  EDIT_VARIATION_OPTIONS = 'editVariationOptions',
  DELETE_VARIATIONS = 'deleteVariations',
}

export enum GENERAL_ACTIONS_TYPES {
  OPEN_DISCONNECT_CHANNEL_ACCOUNT_DIALOG = 'openDisconnectChannelAccountDialog',
  DISCONNECT_CHANNEL_ACCOUNT = 'disconnectChannelAccount',
  OPEN_ADD_CHANNEL_ACCOUNT_DIALOG = 'openAddChannelAccountDialog',
  ADD_CHANNEL_ACCOUNT = 'addChannelAccount',
  RENEW_EBAY_TOKEN = 'renewEbayToken',
  OPEN_IMPORT_PRODUCTS_FROM_EBAY_DIALOG = 'openImportProductsFromEbay',
  OPEN_IMPORT_PRODUCTS_FROM_AMAZON_DIALOG = 'openImportProductsFromAmazon',
  IMPORT_PRODUCTS_FROM_EBAY = 'importProductsFromEbay',
  IMPORT_PRODUCTS_FROM_AMAZON = 'importProductsFromAmazon',
  MAP_PRODUCT_PROPERTY = 'MapProductProperty',
  CONNECT_EBAY_SELLER = 'connectEbaySeller',
  OPEN_PUBLISH_TO_EBAY_DIALOG = 'openPublishToEbayDialog',
  OPEN_PUBLISH_TO_AMAZON_DIALOG = 'openPublishToAmazonDialog',
  OPEN_DELETE_PRODUCTS_DIALOG = 'openDeleteProductsDialog',
  OPEN_DELETE_SINGLE_PRODUCTS_DIALOG = 'openDeleteSingleProductsDialog',
  DELETE_PRODUCTS = 'deleteProducts',
  OPEN_PUBLISH_TO_EBAY_PAGE = 'openPublishToEbayPage',
  OPEN_PUBLISH_TO_AMAZON_PAGE = 'openPublishToAmazonPage',
  OPEN_IMPORT_AMAZON_CSV_DIALOG = 'openImportAmazonCsvDialog',
  OPEN_IMPORT_PRODUCTS_CSV_DIALOG = 'openImportProductsCsvDialog',
  OPEN_UPDATE_PRODUCTS_CSV_DIALOG = 'openUpdateProductsCsvDialog',
  IMPORT_AMAZON_CSV = 'importAmazonCsv',
  IMPORT_INVENTORY_CSV = 'importInventoryCsv',
  OPEN_PUBLISH_TO_EBAY_CONFIRMATION_DIALOG = 'openPublishToEbayConfirmationDialog',
  OPEN_PUBLISH_TO_AMAZON_CONFIRMATION_DIALOG = 'openPublishToAmazonConfirmationDialog',
  OPEN_IMPORT_PAGE = 'openImportsPage',
  OPEN_ADD_PRODUCT_VARIATION_DIALOG = 'openAddProductVariationDialog',
  OPEN_EDIT_PRODUCT_VARIATION_OPTIONS_DIALOG = 'openEditProductVariationOptionsDialog',
  ADD_SINGLE_PRODUCT_VARIATION = 'addSingleProductVariation',
  EDIT_PRODUCT_VARIATION_OPTIONS = 'editProductVariationOptions',
  DELETE_PRODUCT_VARIATIONS = 'deleteProductVariations',
  OPEN_NEW_PRODUCT_PAGE = 'openNewProductPage',
  OPEN_LINK_TO_PRODUCT_DIALOG = 'openLinkToProductDialog',
  OPEN_CREATE_PRODUCT_FROM_LISTING_DIALOG = 'openCreateProductFromListingDialog',
  LINK_TO_PRODUCT = 'linkToProduct',
  CREATE_PRODUCT_FROM_LISTING = 'createProductFromListing',
  UNLINK_FROM_PRODUCT = 'unlinkFromProduct',
  GO_TO_PRODUCT = 'goToProduct',
  OPEN_UPDATE_INVENTORY_CSV_DIALOG = 'openUpdateInventoryCsvDialog',
  ENABLE_SYNC = 'enableSync',
  SYNC_LISTINGS_FROM_CHANNELS = 'syncListingsFromChannels',
  TURN_PAID_FEATURE_OFF = 'turnPaidFeatureOff',
  RETRY_PAYMENT = 'retryPayment',
  CONTACT_SUPPORT = 'contactSupport',
  OPEN_CREATE_ATTRIBUTE_DIALOG = 'createAttributeDialog',
  OPEN_DELETE_ATTRIBUTE_DIALOG = 'openDeleteAttributeDialog',
  ADD_ATTRIBUTE = 'addAttribute',
  DELETE_ATTRIBUTE = 'deleteAttribute',
}

export enum AMAZON_LISTINGS_ACTIONS_TYPES {
  REFRESH = 'refresh',
  PUBLISH_PRODUCTS_TO_AMAZON = 'publishProductsToAmazon',
}
